import { Card, CardContent } from '@/components/wm';
import * as React from 'react';
import { addSpacersToFeatures, ConditionsList, ExtraSection, FeatureList } from '../index';

export default function SignupPlans ({ plans }) {
    // Get free plan from plans array
    const freePlan = plans.find(plan => plan.slug === 'free');
    // Filter out essentials plan for signup view
    const signupPlans = plans.filter(plan => plan.slug !== 'essentials' && plan.slug !== 'free');

    return (
        <div className="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-4 tw-gap-4 tw-items-stretch">
            <Card className="tw-h-full tw-p-4 tw-bg-primary tw-flex tw-flex-col">
                <div className="tw-flex tw-flex-col tw-items-center tw-mb-1">
                    <div className="tw-text-center tw-font-bold tw-text-lg tw-mb-0 tw-text-white">{freePlan.key}</div>
                    <h4 className="tw-font-bold tw-text-2xl !tw-mb-0 !tw-mt-0">€{freePlan.price}/mo</h4>
                    <span className="tw-text-xs tw-text-muted-foreground tw-opacity-0">{i18next.t('plans.starting_at')}</span>
                </div>
                <CardContent className="tw-flex-1 tw-flex tw-flex-col">
                    <div className="tw-flex tw-flex-col">
                        <div>
                            <p className="tw-font-bold tw-mb-2">{i18next.t('plans.features_label')}</p>
                            <FeatureList className="tw-text-white" features={addSpacersToFeatures(freePlan.features, plans)}/>
                        </div>
                        <div className="tw-border-t tw-border-solid tw-border-white tw-my-3"></div>
                        <div>
                            <ConditionsList className="tw-text-white" conditions={freePlan.conditions}/>
                        </div>
                    </div>
                    <ExtraSection className="tw-text-white" extra={freePlan.extra}/>
                </CardContent>
            </Card>
            {signupPlans.map(plan => (
                <Card className="tw-h-full tw-p-4 tw-flex tw-flex-col" key={plan.key}>
                    <div className="tw-flex tw-flex-col tw-items-center tw-mb-1">
                        <div className="tw-text-center tw-font-bold tw-text-lg tw-mb-0.5 tw-text-primary">{plan.key}</div>
                        <h4 className="tw-font-bold tw-text-2xl !tw-mb-0 !tw-mt-0">€{plan.price}/mo</h4>
                        <span className="tw-text-xs tw-text-muted-foreground">{i18next.t('plans.starting_at')}</span>
                    </div>
                    <CardContent className="tw-flex-1 tw-flex tw-flex-col">
                        <div className="tw-flex tw-flex-col">
                            <div>
                                <p className="tw-font-bold tw-mb-2">{i18next.t('plans.features_label')}</p>
                                <FeatureList className="tw-text-primary" features={addSpacersToFeatures(plan.features, plans)}/>
                            </div>
                            <div className="tw-border-t tw-border-solid tw-border-primary tw-my-3"></div>
                            <div>
                                <ConditionsList className="tw-text-primary" conditions={plan.conditions}/>
                            </div>
                        </div>
                        <ExtraSection className="tw-text-primary" extra={plan.extra}/>
                    </CardContent>
                </Card>
            ))}
        </div>
    );
}
